import { createSlice } from "@reduxjs/toolkit";

import type { IPlayer } from "../../types";

export const initialState = {
  currentPitcher: {} as IPlayer,
  pitchCount: 0 as number,
  isBullpenActive: false as boolean,
};

const bullpenSlice = createSlice({
  name: "bullpen",
  initialState,
  reducers: {
    setBullpenPitcher: (state, action) => {
      state.currentPitcher = action.payload;
    },
    incrementBullpenPitchCount: (state) => {
      state.pitchCount = state.pitchCount + 1;
    },
    resetBullpenPitchCount: (state) => {
      state.pitchCount = 0;
    },
    setBullpenActive: (state, action) => {
      state.isBullpenActive = action.payload;
    },
    endBullpen: (state) => {
      state = {
        currentPitcher: {} as IPlayer,
        pitchCount: 0,
        isBullpenActive: false,
      };
      return state;
    },
  },
});

export const {
  setBullpenPitcher,
  incrementBullpenPitchCount,
  resetBullpenPitchCount,
  setBullpenActive,
  endBullpen,
} = bullpenSlice.actions;
export default bullpenSlice.reducer;
